<template>
  <svg
    :width="computedWidth"
    :height="computedHeight"
    viewBox="0 0 47 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g :fill="color">
        <path d="M3.91666667,5.0483137 C1.7578,5.0483137 3.55271368e-15,6.78698336 3.55271368e-15,8.92961785 L3.55271368e-15,36.1180724 C3.55271368e-15,38.2613303 1.75278667,40 3.91666667,40 L43.0833333,40 C45.2422,40 47,38.263824 47,36.1180724 L47,8.92961785 C47,6.78698336 45.2472133,5.0483137 43.0833333,5.0483137 L37.0391333,5.0483137 C35.9575067,5.0483137 34.7900267,4.22479895 34.6672,3.88192756 C33.9083067,1.73617605 31.53888,4.08562073e-13 29.375,4.08562073e-13 L17.625,4.08562073e-13 C15.4636267,4.08562073e-13 13.0916933,1.73617605 12.3328,3.88192756 C12.1046933,4.52465557 11.0475067,5.0483137 9.96086667,5.0483137 L3.91666667,5.0483137 Z M23.5,34.1749268 C29.9891333,34.1749268 35.25,28.9589178 35.25,22.5254037 C35.25,16.0893959 29.9891333,10.8727635 23.5,10.8727635 C17.0108667,10.8727635 11.75,16.0893959 11.75,22.5254037 C11.75,28.9589178 17.0108667,34.1749268 23.5,34.1749268 Z M23.5,31.3636364 C28.2406851,31.3636364 32.0865385,27.4973251 32.0865385,22.7291209 C32.0865385,17.9572204 28.2406851,14.0909091 23.5,14.0909091 C18.7593149,14.0909091 14.9134615,17.9572204 14.9134615,22.7291209 C14.9134615,27.4973251 18.7593149,31.3636364 23.5,31.3636364 Z" />
      </g>
    </g>
  </svg>
</template>

<script>
import MixinIcon from '@/mixins/icon'
export default {
  mixins: [MixinIcon],
  data: () => ({
    DEFAULT_WIDTH: 47,
    DEFAULT_HEIGHT: 40,
  }),
}
</script>
